import { FadeIn } from "./FadeIn";
import { ArrowUpRight } from "lucide-react";
import { WA_LINK } from "../constants/contact";

const SERVICES = [
  {
    title: "Elektrik Arıza & Tamir",
    desc: "Kısa devre, atan sigorta, kablo erimesi ve voltaj problemleri tespiti ve usta elinden garantili onarım.",
    tag: "ACİL SERVİS",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHJlcGFpcmluZyUyMHdpcmVzJTIwd29ya3xlbnwwfHx8fDE3OTM3Nzk1NTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Sigorta & Pano İşleri",
    desc: "Sigorta kutusu değişimi, kaçak akım rölesi montajı, ana şalter ve klemens yenileme.",
    tag: "GÜVENLİK",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1786177590769-f3b9fc8eb5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbGVjdHJpY2lhbiUyMHBhbmVsJTIwZnVzZXMlMjBicmVha2VyJTIwYm94fGVufDB8fHx8MTc5Mzc3OTU1MHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Aydınlatma & LED Montajı",
    desc: "Avize montajı, gizli LED şerit çekimi, spot lambaları, bahçe ve alan aydınlatma tesisatı.",
    tag: "DEKORATİF",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1504972090022-6edb81e4e534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjZWlsaW5nJTIwbGlnaHQlMjBidWxiJTIwaW50ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc5Mzc3OTU1N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Priz & Anahtar Montajı",
    desc: "Eski priz/anahtar değişimi, ilave priz hattı çekimi, TV ve internet altyapı sonlandırma.",
    tag: "MONTAJ",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1590059694337-ec9f631ec9a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdpcmluZyUyMHRvb2xzJTIwZGFyayUyMGRyYW1hdGljJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkzNzc5NTUwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Kamera & Güvenlik Sistemleri",
    desc: "Kablolu/kablosuz kamera kurulumu, kayıt cihazı bağlantısı ve telefondan uzaktan izleme ayarı.",
    tag: "GÜVENLİK",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1617897903246-719242758050?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw1fHxzZWN1cml0eSUyMGNhbWVyYSUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3OTM3OTQ4MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Diafon & Görüntülü Kapı Telefonu",
    desc: "Bina ve daire diafon montajı, görüntülü kapı telefonu değişimi ve arıza onarımı.",
    tag: "MONTAJ",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGhvbWUlMjBpbnRlcmNvbSUyMGRvb3JiZWxsfGVufDB8fHx8MTc5Mzc5NDgzNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "İnternet & Data Hattı",
    desc: "Cat6 data kablosu çekimi, modem/router kurulumu, oda içi internet prizi ve kablo sonlandırma.",
    tag: "ALTYAPI",
    span: "md:col-span-1",
    image:
      "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwY2FibGVzJTIwZXRoZXJuZXR8ZW58MHx8fHwxNzkzNzk0ODM2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Uydu & TV Tesisatı",
    desc: "Uydu anten ayarı, çanak montajı, kablo hattı çekimi ve merkezi uydu dağıtım bağlantıları.",
    tag: "TAKİP & MONTAJ",
    span: "md:col-span-2",
    image:
      "https://images.unsplash.com/photo-1593784991095-a205069470b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzYXRlbGxpdGUlMjBkaXNoJTIwcm9vZnRvcHxlbnwwfHx8fDE3OTM3OTQ4MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const Services = () => (
  <section id="hizmetler" data-testid="services-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 mb-4">
          Ustalık Hizmetleri
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 max-w-2xl leading-tight">
          Tüm elektrik işleriniz. <span className="text-slate-500">Temiz, garantili, net.</span>
        </h2>
      </FadeIn>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <FadeIn key={s.title} delay={i * 0.08} className={s.span}>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-card-${i}`}
              className="group relative block h-full min-h-[300px] rounded-3xl overflow-hidden border border-slate-800 bg-[#0F172A] hover:border-amber-500/50 transition-colors duration-300"
            >
              <img
                src={s.image}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070A0F] via-[#070A0F]/55 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-7 sm:p-8">
                <span className="inline-flex w-fit rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-amber-400 uppercase mb-4">
                  {s.tag}
                </span>
                <div className="flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display font-bold text-xl sm:text-2xl text-slate-50 tracking-tight">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed max-w-md">{s.desc}</p>
                  </div>
                  <span className="shrink-0 flex items-center justify-center w-11 h-11 rounded-full border border-slate-700 text-slate-400 group-hover:bg-amber-500 group-hover:border-amber-500 group-hover:text-black transition-all duration-300">
                    <ArrowUpRight className="w-5 h-5" strokeWidth={2.25} />
                  </span>
                </div>
              </div>
            </a>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
